import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useEffect, useState, type ReactNode } from 'react';

const links = [
  { to: '/', label: 'Overzicht', end: true },
  { to: '/cases', label: 'Zaken' },
  { to: '/search', label: 'Berichten' },
  { to: '/discover', label: 'Ontdekken' },
  { to: '/sources', label: 'Bronnen' },
  { to: '/ingest', label: 'Inladen' },
  { to: '/alerts', label: 'Alerts' },
  { to: '/tasks', label: 'Taken' },
  { to: '/lookup', label: 'Gebruiker' },
  { to: '/bookmarks', label: 'Opgeslagen' },
  { to: '/jobs', label: 'Jobs' },
];

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  return (
    <div className={`app-shell${menuOpen ? ' nav-open' : ''}`}>
      <header className="mobile-topbar">
        <button
          className="nav-toggle"
          type="button"
          aria-label={menuOpen ? 'Menu sluiten' : 'Menu openen'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="mobile-brand">
          <div className="brand-mark">OSINT</div>
          <div className="brand-sub">Is Huso er toch nog bij :)</div>
        </div>
      </header>

      {menuOpen && (
        <button
          className="nav-backdrop"
          type="button"
          aria-label="Menu sluiten"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <aside className="sidebar">
        <div className="brand desktop-brand">
          <div className="brand-mark">OSINT</div>
          <div className="brand-sub">Is Huso er toch nog bij :)</div>
        </div>
        <nav className="nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => (isActive ? 'active' : '')}>
              {l.label}
            </NavLink>
          ))}
          {user?.role === 'admin' && (
            <>
              <NavLink to="/telegram" className={({ isActive }) => (isActive ? 'active' : '')}>
                Telegram
              </NavLink>
              <NavLink to="/users" className={({ isActive }) => (isActive ? 'active' : '')}>
                Gebruikers
              </NavLink>
            </>
          )}
        </nav>
        <div className="sidebar-user">
          <div className="name">{user?.name}</div>
          <div className="meta">
            {user?.email} · {user?.role === 'admin' ? 'beheerder' : 'analist'}
          </div>
          <button className="btn btn-ghost btn-sm" type="button" onClick={() => void logout()}>
            Uitloggen
          </button>
        </div>
      </aside>
      <main className="main">{children}</main>
    </div>
  );
}
